<ffd-tooth-details
  [vm]="toothDetails()"
  (closeClick)="onCloseClick()"
  (leftClick)="onLeftClick()"
  (rightClick)="onRightClick()"
  (visitDateClick)="onVisitDateClick($event)"
  (hideConditionClick)="onHideConditionClick($event)"
  (deleteProgressNoteClick)="onDeleteProgressNoteClick($event)"
  (toggleClick)="onToggleClick($event)"
></ffd-tooth-details>
